export const difusionesConstants = {
    GET_DIFUSIONES_AYTOID_REQUEST: "GET_DIFUSIONES_AYTOID_REQUEST",
    GET_DIFUSIONES_AYTOID_SUCCESS: 'GET_DIFUSIONES_AYTOID_SUCCESS',
    GET_DIFUSIONES_AYTOID_FAILURE: 'GET_DIFUSIONES_AYTOID_FAILURE'
};